import { Overlay } from '@eti/components';
import LoungeDrawerContent from './LoungeDrawerContent';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LoungeDrawer = ({
  isOpen,
  labels,
  loungeInfo,
  onClose
}) => {
  if (!loungeInfo) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Overlay.Drawer, {
    dataTestId: "airport-drawer",
    handleClose: onClose,
    id: "lounge-info-drawer",
    isOpen: isOpen,
    children: [/*#__PURE__*/_jsx(Overlay.Header, {
      onClose: onClose,
      title: loungeInfo.loungeName
    }), /*#__PURE__*/_jsx(Overlay.Content, {
      children: /*#__PURE__*/_jsx(LoungeDrawerContent, {
        labels: labels,
        loungeInfo: loungeInfo
      })
    })]
  });
};
export default LoungeDrawer;
//# sourceMappingURL=LoungeDrawer.js.map